export const formClickToTextStepVariant = ['appearance', 'settings', 'code'] as const
export type FormClickToTextStep = (typeof formClickToTextStepVariant)[number]

export const formSubscribeStepVariant = [
  'appearance',
  'settings',
  'settings/targeting',
  'settings/subscribers',
  'settings/confirmation',
  'texts',
  'texts/compilance',
  'landing',
  'code',
] as const
export type FormSubscribeStep = (typeof formSubscribeStepVariant)[number]
